export default __webpack_public_path__ + "static/media/certification8.b8a5ebad.jpg";